import React from "react";
import MuiTextField from "@material-ui/core/TextField";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { getFieldStatus } from "./common";

const TextField = ({
  classes,
  name,
  label: labelProp = name,
  value: valueProp,
  disabled: disabledProp,
  readOnly = false,
  InputProps,
  fast = true,
  FieldComponent = fast ? FastField : Field,
  onChange,
  ...props
}) => (
  <FieldComponent name={name}>
    {({ field, form }) => {
      const onFieldChange = e => {
        field.onChange(e);
        onChange && onChange(e, form, field);
      };

      const { error, hasError, disabled, label, value } = getFieldStatus(
        form,
        field,
        valueProp,
        labelProp,
        disabledProp
      );

      const fieldVal = value === undefined || value === null ? "" : value;

      if (typeof InputProps === "function")
        InputProps = InputProps(field.value, form, name);

      return (
        <MuiTextField
          label={label}
          name={name}
          onBlur={(!readOnly && field.onBlur) || undefined}
          onChange={(!readOnly && onFieldChange) || undefined}
          value={fieldVal}
          error={hasError}
          helperText={hasError && error}
          disabled={disabled}
          classes={classes}
          InputProps={InputProps}
          {...props}
        />
      );
    }}
  </FieldComponent>
);

export default withStyles(
  { root: { whiteSpace: "nowrap" } },
  { name: "LcTextField" }
)(TextField);
